<script setup lang="ts">
    import { LEARNING_PROFESSIONS } from '~/types/professions';

    const { lang } = useLanguage();
    const { t } = useI18n();

    const { userShopware } = useLoginState();
    const { accountBasePath } = useAccountBasePath();
    const userCustomFields = computed(() => userShopware.value?.customFields ?? {});
    const profession = computed(() =>
        typeof userCustomFields.value === 'object' && 'custom_middleware_customer_profession' in userCustomFields.value
            ? userCustomFields.value.custom_middleware_customer_profession
            : undefined
    );
    const isVisible = computed(
        () => typeof profession.value === 'string' && LEARNING_PROFESSIONS.includes(profession.value)
    );
</script>

<template>
    <div
        v-if="isVisible"
        class="score-wrapper"
    >
        <div class="info-text">
            <p>
                <i18n-t
                    keypath="account.score.bonusText"
                    :locale="lang"
                >
                    <template #bonusLink>
                        <NuxtLink :to="`${accountBasePath}/bonus`">
                            {{ t('account.score.bonusLinkText') }}
                        </NuxtLink>
                    </template>
                </i18n-t>
            </p>

            <p>
                <i18n-t
                    keypath="account.score.faqText"
                    :locale="lang"
                >
                    <template #faqLink>
                        <a
                            href="/pta-family/teilnahmebedingungen/faq-bonusprogramm"
                            target="_blank"
                        >
                            {{ t('account.score.faqLinkText') }}
                        </a>
                    </template>
                </i18n-t>
            </p>

            <p>{{ t('account.score.collectMoreText') }}</p>
        </div>
    </div>
</template>

<style scoped>
    @import '~/assets/scss/account/account-score.scss';
</style>
